import React, { useCallback, useState } from 'react';
import { DiroCalendar } from '../diro-calendar';
import { fetchProfessorLecturesOperation } from './operations/fetch-professor-lectures-operation';

export const ProfessorCalendar: React.FC<{ professorId: number }> = ({
  professorId,
}) => {
  const [lectures, setLectures] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const handleRangeChange = useCallback(
    async (startDate: Date, endDate: Date) => {
      await fetchProfessorLecturesOperation(
        professorId,
        {
          offset: 0,
          limit: 1000,
          startDate,
          endDate,
        },
        setLoading,
        setLectures,
      );
    },
    [professorId],
  );

  return (
    <DiroCalendar
      data={lectures}
      loading={loading}
      onDateRangeChange={handleRangeChange}
    />
  );
};
